import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';

const Authorization = lazyWithRetry(() => import('./Authorization'));

const AuthorizationRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="authorization-settings">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Authorization />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default AuthorizationRoutes;
